import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { BrochureAnalysisService } from 'src/app/trip-calculator/services/brochure-analysis.service';
import { TripCreationModalService } from 'src/app/trip-calculator/services/trip-creation-modal.service';
import { UploadConfigService } from 'src/app/shared/services/upload-config.service';
import { TripLimitIndicatorComponent } from 'src/app/shared/components/trip-limit-indicator/trip-limit-indicator.component';
import { PackLimitationsService } from 'src/app/shared/services/pack-limitations.service';
import { TooltipModule } from 'primeng/tooltip';
import { CommonModule } from '@angular/common';
import { LimitedFeatures } from 'src/app/shared/models/pack.models';
import { NotificationService } from 'src/app/core/services/notification.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-creation-method-selector',
  imports: [
    TranslocoModule,
    ButtonModule,
    TripLimitIndicatorComponent,
    TooltipModule,
    CommonModule,
  ],
  templateUrl: './creation-method-selector.component.html',
})
export class CreationMethodSelectorComponent {
  /** Build-time switch, mirrors FEATURE_*_ENABLED on the API. */
  protected readonly features = environment.features;
  tripCreationModalService = inject(TripCreationModalService);
  brochureAnalysisService = inject(BrochureAnalysisService);
  uploadConfigService = inject(UploadConfigService);
  packLimitationService = inject(PackLimitationsService);
  notificationService = inject(NotificationService);
  translocoService = inject(TranslocoService);
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  createTripWithIA(): void {
    // Ouvre simplement le sélecteur de fichier
    this.fileInput.nativeElement.click();
  }

  createTripWithBulkIA(): void {
    this.brochureAnalysisService.showBulkUploadModal.set(true);
    this.tripCreationModalService.close();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      const file = input.files[0];
      const config = this.uploadConfigService.AI_DOCUMENT;

      if (file.size > config.maxSize) {
        this.notificationService.error(
          this.translocoService.translate('calculator.fileTooBigError', {
            maxSize: config.maxSizeMB,
          }),
        );
        input.value = ''; // réinitialise l'input
        return;
      }
      this.brochureAnalysisService.showBrochureAnalysisModal.set(true);
      this.tripCreationModalService.close();

      // Utiliser le service pour gérer l'analyse
      this.brochureAnalysisService.startAnalysis(file);

      // Réinitialiser l'input file
      input.value = '';
    } else {
      console.error('No file selected');
    }
  }

  handleBulkIAClick() {
    if (
      this.packLimitationService.canCreateTrip() &&
      this.packLimitationService.canUseBulkUpload()
    ) {
      this.createTripWithBulkIA();
    } else if (this.packLimitationService.canCreateTrip()) {
      this.packLimitationService.openModal(LimitedFeatures.BulkUpload);
    }
  }
}
